import AvatarIcon from "@/assets/images/pictures/avatar_placeholder.svg?inline";
import AddAvatarIcon from "@/assets/images/icons/add-avatar.svg?inline";

import { Cropper, CircleStencil } from "vue-advanced-cropper";

import { UPDATE_USER_AVATAR } from "../../views/agent/gql/AgentProfileQueries";

export default {
  name: "user_avatar",

  data() {
    return {
      cacheAvatarFile: null,
      blobAvatarFile: null,
      userAvatar: null,
      croppedAvatar: null,
      uploadingAvatar: false
    };
  },

  props: ["avatar"],

  mounted: function() {
    this.userAvatar = this.avatar;
  },

  // computed: {
  //   userAvatar() {
  //     if (this.avatar) {
  //       return this.avatar;
  //     }
  //   }
  // },

  watch: {
    avatar: function(newV) {
      if (newV) {
        this.userAvatar = newV;
      }
    }
  },

  methods: {
    addAvatarFile(event) {
      let input = event.target;

      if (input.files && input.files[0]) {
        this.cacheAvatarFile = input.files[0];

        let reader = new FileReader();

        reader.onload = e => {
          this.blobAvatarFile = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);

        this.$refs.modalAvatar.show();
      }
    },

    clearCrop() {
      this.$refs.avatarField.value = "";
    },

    hideModal() {
      this.$refs.modalAvatar.hide();
    },

    cropAvatar() {
      this.uploadingAvatar = true;

      const { coordinates, canvas } = this.$refs.cropper.getResult();

      // You able to do different manipulations at a canvas
      // but there we just get a cropped image

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_AVATAR,
          fetchPolicy: "no-cache",
          variables: {
            avatar: this.cacheAvatarFile,
            cropParams: coordinates
          }
        })
        .then(({ data: { updateUserAvatar } }) => {
          // this.userAvatar = canvas.toDataURL();
          this.$store.commit("setUserAvatar", updateUserAvatar.avatar);
          this.userAvatar = updateUserAvatar.avatar;
          this.hideModal();
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.uploadingAvatar = false;
        });
    }
  },

  components: {
    AvatarIcon,
    AddAvatarIcon,
    Cropper,
    CircleStencil
  }
};
